.rootElement {
	height: 100%;
	display: flex;
	flex-direction: column;
}

.contentElement {
	flex: auto;
}

.footerElement {
	bottom: 0;
	display: flex;
	width: 100%;
}
